import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/light-bulb-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-aeeb8d3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "view-pathway"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"margin-inline":"auto"},
  class: "text-center"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Good luck on your journey!")
], -1))
const _hoisted_3 = { class: "animation-container" }
const _hoisted_4 = { class: "view-pathway-description" }
const _hoisted_5 = { class: "pathway-header" }
const _hoisted_6 = { class: "pathway-header-text" }
const _hoisted_7 = { "data-test": "view-pathway-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Pathway: ", -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "pathway-header-image" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "pathway-section" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  class: "practicalities-list",
  "data-test": "view-pathway-practicalities"
}
const _hoisted_15 = { class: "practicality-title" }
const _hoisted_16 = ["alt"]
const _hoisted_17 = ["innerHTML"]

import axios from "axios";
import { debug as d } from "debug";
import { Modal } from "uiv";
import { onBeforeMount, ref, computed } from "vue";
import { useRoute } from "vue-router";
import cms from "../../services/cms/cms";
import { CmsTeamGoal, CmsTeamPathway } from "../../services/cms/cms-type-definitions";
import { TeamPathwayApiModel } from "../../api-models";
import LoadingPage from "../../views/loading-page.vue";
import { Analytics } from "../../services/analytics/analytics";
import { csContext } from "../../services/cs-context";
import LottieProgressBar from "../lottie-progress-bar.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'view-pathway',
  emits: ["hide-stepper"],
  setup(__props, { emit: __emit }) {

const debug = d("cs.PackagesPage");

const route = useRoute();
const asaccredited = computed(() => route.query.asaccredited as string);

const pathwayUid = ref("");
const teamId = ref("");
const outcomeUid = ref("");
const pathway = ref<CmsTeamPathway | null>(null);
const outcome = ref<CmsTeamGoal | null>(null);
const expanded = ref(false);
const selectedPathwayApiModel = ref<TeamPathwayApiModel | null>(null);
const showModal = ref(false);

onBeforeMount(async () => {
  pathwayUid.value = route.params.pathwayUid as string;
  outcomeUid.value = route.params.outcomeUid as string;
  teamId.value = route.params.id as string;
  pathway.value = await cms.getByUid("cms-pathway", pathwayUid.value);
  outcome.value = await cms.getByUid("cms-goal", outcomeUid.value);

  Analytics.action("Viewed Team Pathway Details", "TeamPathwayActions", {
    outcomeUid: outcomeUid.value,
    outcomeTitle: cms.asText(outcome.value.data.full_title),
    pathwayId: pathway.value?.id,
    pathwayUid: pathwayUid.value,
    pathwayName: pathway.value?.data?.title[0].text,
    pathwayTitle: cms.asText(pathway.value.data.title),
  });
});

function toggle(): void {
  expanded.value = !expanded.value;
}

const emit = __emit;
const lottieProgressBar = ref();

function saveTeamPathway(): void {
  if (!pathway.value || !outcome.value) {
    throw new Error("Need to have pathway & outcome in place to save");
  }

  if (!pathway.value.uid || !outcome.value.uid) {
    throw new Error("Pathway and outcome need to have UIDs set");
  }

  selectedPathwayApiModel.value = {
    triggeringUserId: csContext.user.id,
    cmsPathwayId: pathway.value.id,
    cmsPathwayUid: pathway.value.uid,
    cmsPathwayTitle: cms.asText(pathway.value.data.title),
    cmsOutcomeTitle: cms.asText(outcome.value.data.full_title),
    cmsOutcomeUid: outcome.value.uid,
    cmsOutcomeId: outcome.value.id,
    isCurrent: true,
    completed: false,
  };
  axios.post(`/api/teampathway/${teamId.value}`, selectedPathwayApiModel.value).then((response) => {
    debug("Team pathway saved", response);
    emit("hide-stepper");
    showModal.value = true;
    (lottieProgressBar.value as any).playAnimation();
    setTimeout(() => {
      window.location.href = asaccredited.value === 'true'
        ? `/myorganisation/group/details/${teamId.value}`
        : `/home?team=${teamId.value}`;
    }, 3000);
  });
}

return (_ctx: any,_cache: any) => {
  return (pathway.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(Modal), {
          modelValue: showModal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event)),
          footer: false,
          header: false,
          backdrop: false,
          "data-test": "team-modal-animation"
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", _hoisted_3, [
              _createVNode(LottieProgressBar, {
                ref_key: "lottieProgressBar",
                ref: lottieProgressBar,
                width: "75%"
              }, null, 512)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                _hoisted_8,
                _createTextVNode(_toDisplayString(_unref(cms).asText(pathway.value.data.title)), 1)
              ]),
              _createElementVNode("div", {
                innerHTML: _unref(cms).asHtml(pathway.value.data.short_description),
                "data-test": "view-short-desc"
              }, null, 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("img", {
                src: pathway.value.data.title_image.url,
                alt: _unref(cms).asText(pathway.value.data.title),
                "data-test": "view-pathway-img"
              }, null, 8, _hoisted_11)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", {
              innerHTML: _unref(cms).asHtml(pathway.value.data.description),
              "data-test": "view-pathway-desc"
            }, null, 8, _hoisted_13)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathway.value.data.practicalities, (p, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `practicalities` + index,
                  class: "practicalities-list-item"
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: `benefit` + (index + 1)
                    }, null, 8, _hoisted_16),
                    _createElementVNode("p", null, _toDisplayString(_unref(cms).asText(p.practicality_title)), 1)
                  ]),
                  _createElementVNode("p", {
                    class: "practicality-desc-item",
                    innerHTML: _unref(cms).asHtml(p.practicality_description)
                  }, null, 8, _hoisted_17)
                ]))
              }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", { class: "btn-container" }, [
          _createElementVNode("button", {
            onClick: saveTeamPathway,
            class: "btn btn-primary",
            "data-test": "pathway-save",
            type: "button"
          }, " Go! ")
        ])
      ]))
    : (_openBlock(), _createBlock(LoadingPage, { key: 1 }))
}
}

})